import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const Panel = styled.aside`
  background: #F5F9FC;
  border: 1px solid #D0E0F0;
  border-radius: ${p => p.theme.radius.md}px;
  padding: ${p => p.theme.spacing[4]}px;
  margin: ${p => p.theme.spacing[4]}px 0;
  font-size: ${p => p.theme.typography.sizes.sm};
  line-height: 1.6;
  color: ${p => p.theme.colors.text.primary};
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
`;

const Title = styled.h4`
  font-size: ${p => p.theme.typography.sizes.md};
  font-weight: ${p => p.theme.typography.weights.semibold};
  color: ${p => p.theme.colors.text.primary};
  margin: 0 0 ${p => p.theme.spacing[2]}px 0;
`;

const Body = styled.p`
  margin: 0;
`;

const DeltaNote = styled.p`
  margin-top: ${p => p.theme.spacing[3]}px;
  margin-bottom: 0;
  font-size: ${p => p.theme.typography.sizes.xs};
  color: ${p => p.theme.colors.text.muted};
  font-style: italic;
`;

const EducationalPanel = ({ lang = 'en' }) => {
  const t = useLocale(lang, 'comparison');

  return (
    <Panel>
      <Title>{t.educational?.title || 'Why do these differ?'}</Title>
      <Body>{t.educational?.body || 'Thirukanitha uses NASA JPL DE431 ephemeris with modern astronomical models. Vakyam uses traditional Surya Siddhanta formulas.'}</Body>
      <DeltaNote>{t.educational?.deltaNote || 'Delta = Vakyam \u2212 Thirukanitha. Positive means Vakyam is later.'}</DeltaNote>
    </Panel>
  );
};

export default EducationalPanel;
